import {Component, OnDestroy, OnInit} from "@angular/core";
import {Subscription} from "rxjs";
import {UtilsService} from "../../../../core/utils/utils.service";
import {Auth2Service} from "../../../../core/services/security/auth2.service";
import {RoutemapService} from "../../../../core/services/routemap.service";
import {GenericManageDialogService} from "../../../../core/services/generics/generic-manage-dialog.service";
import {GenericDatagridService} from "../../../../core/services/generics/generic-datagrid.service";
import {DialogMsgSupplier, Paragraphe} from "../../../../core/suppliers/dialog-msg-supplier";
import {EquipementPmsSavedSupplier, EquipementPmsService} from "../../../../core/services/pms/equipement-pms.service";
import {EquipementPmsDto} from "../../../../core/dtos/pms/equipement-pms-dto";
import {InternationalizationService} from "../../../../core/services/i8n/i8n.service";
import {HELP_FOLDERS, MSG_KEY, MSG_SEVERITY} from "../../../../core/constants";
import {Title} from "@angular/platform-browser";
import {confirm} from "devextreme/ui/dialog";
import {ToastService} from "../../../../core/services/technique/toast.service";

@Component({
  selector: 'yo-pms-equipement-grille',
  templateUrl: './pms-equipement-grille.component.html',
  styleUrls: ['./pms-equipement-grille.component.scss']
})
export class PmsEquipementGrilleComponent implements OnInit, OnDestroy {
  equipementsList: EquipementPmsDto[] = [];

  hasPms = false;

  subEquipementSaved: Subscription;

  entityName: string;
  allMode: string;
  checkBoxesMode: string;
  selectedRows: number[] = [];

  pathFile: string = HELP_FOLDERS.PMS + '/pms-equipements';

  constructor(public utils: UtilsService,
              private auth2Svc: Auth2Service,
              private routeMapSvc: RoutemapService,
              private genericManageDialogService: GenericManageDialogService,
              public gds: GenericDatagridService,
              private i8nSvc: InternationalizationService,
              private equipementPmsSvc: EquipementPmsService,
              private title: Title,
              private toastSvc: ToastService) {}

  ngOnInit(): void {
    this.initHasPms();
    this.initEquipementsPms();
    this.equipementSavedSubscription();
    this.initProperty();
  }

  initProperty = (): void => {
    this.allMode = 'allPages';
    this.checkBoxesMode = 'always';
    this.entityName = this.equipementPmsSvc.getEntityName().toLowerCase();
    this.title.setTitle(this.getTitle());
  };

  ngOnDestroy(): void {
    this.utils.unsubscribe(this.subEquipementSaved);
  }

  getTitle = (): string => "GESTION DES EQUIPEMENTS";

  canEdit = (): boolean => this.hasPms && this.auth2Svc.hasSitesLocaux();

  initEquipementsPms = (): void => {
    this.equipementPmsSvc.getAll()
      .subscribe(response => {
        this.equipementsList = response.resultList;
      });
  };

  initHasPms = (): void => {
    this.auth2Svc.hasPms$.subscribe(response => this.hasPms = response);
  };

  equipementSavedSubscription = (): void => {
    this.subEquipementSaved = this.equipementPmsSvc.equipementSaved$
      .subscribe((response: EquipementPmsSavedSupplier) => {
        if (!response.isUpdate) {
          this.equipementsList.push(response.equipement);
        }
      });
  };

  openEquipement = (e: EquipementPmsDto): void => {
    this.equipementPmsSvc.announceOpenDialog(e);
  };

  deleteValues = async (): Promise<void> => {
    const result = confirm('Êtes-vous sûr de vouloir supprimer le(s) élément(s) sélectionnés ?', 'Confirmation');
    const isDeleted: boolean = await result;
    if(isDeleted) {
      const idsToDelete: number[] = this.selectedRows
        .map((idSelected: number) => this.equipementsList.find(e => e.id === idSelected))
        .map((equipement: EquipementPmsDto) => equipement.id);
      this.equipementPmsSvc.deleteByIds(idsToDelete)
        .subscribe(o => {
          this.equipementsList = this.utils.handleIsDeletableResultWithNum(o.one, idsToDelete, this.equipementsList);
          this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `La suppression a été réalisée avec succès`);
        });
    }
  };

  public help = (): DialogMsgSupplier => {
    const dms = new DialogMsgSupplier();
    dms.title = `Les équipements PMS (Plan de Mesure Sanitaire)`;
    dms.logo = 'fa fa-question-circle  yoni-color';
    const p1: Paragraphe = new Paragraphe();
    p1.title = ``;
    p1.lines = [
    ];

    dms.content = {
      intro: ``,
      paragraphes: []
    };

    return dms;
  };
}
